import React, { ReactNode, PureComponent } from 'react'
import { Modal, Title, Button, Text } from '../shared'
import './mail-sent-modal.scss'

interface IProps {
  onClose: () => void
  isHidden: boolean
}

export class MailSentModal extends PureComponent<IProps> {
  public render(): ReactNode {
    const { onClose, isHidden } = this.props
    return (
      <Modal isHidden={ isHidden } className="mail-sent-modal">
        <Title label="resetPasswordMailSent" />
        <Text label="forgotPasswordEmailSent" />
        <Button label="close" onClick={ onClose } />
      </Modal>
    )
  }
}
